import { __assign } from "tslib";
/** Symbol to signal "pull this field from context" */
export var BiContextProvidedValue = Symbol('BiContextProvidedValue');
/** BiData that supports pulling from context, use for logging from components */
export function BiData(data) {
    return __assign(__assign({}, data), { _biLoggerVersion: 2 });
}
//# sourceMappingURL=context.js.map